import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Layout from '../../components/layout/Layout';
import {
  fetchRecebiveis,
  updateRecebivelStatus,
  deleteRecebivel,
  clearAllRecebiveis,
} from '../../services/recebiveisService';
import FiltroRecebiveis from '../../components/recebiveis/FiltroRecebiveis';
import InserirRecebivel from '../../components/recebiveis/InserirRecebivel';
import RecebiveisList from '../../components/recebiveis/RecebiveisList';
import Button from '../../components/common/Button';

function RecebiveisPage() {
  const [recebiveis, setRecebiveis] = useState([]);
  const [filtro, setFiltro] = useState({
    status: 'Todos',
    clinica: '',
    plantao: '',
    paciente: '',
  });

  useEffect(() => {
    async function loadRecebiveis() {
      try {
        const fetchedRecebiveis = await fetchRecebiveis(filtro);
        setRecebiveis(fetchedRecebiveis);
      } catch (error) {
        console.error('Erro ao carregar recebíveis:', error);
      }
    }

    loadRecebiveis();
  }, [filtro]);

  const totalRecebiveis = recebiveis.reduce(
    (acc, recebivel) => acc + (recebivel.valor || 0),
    0
  );
  const totalPendentes = recebiveis
    .filter((r) => r.status === 'Pendente')
    .reduce((acc, recebivel) => acc + (recebivel.valor || 0), 0);
  const totalRecebidos = recebiveis
    .filter((r) => r.status === 'Recebido')
    .reduce((acc, recebivel) => acc + (recebivel.valor || 0), 0);

  const handleStatusChange = async (id, newStatus) => {
    try {
      await updateRecebivelStatus(id, newStatus);
      setRecebiveis((prev) =>
        prev.map((recebivel) =>
          recebivel.id === id ? { ...recebivel, status: newStatus } : recebivel
        )
      );
    } catch (error) {
      console.error('Erro ao atualizar status do recebível:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteRecebivel(id);
      setRecebiveis((prev) => prev.filter((recebivel) => recebivel.id !== id));
    } catch (error) {
      console.error('Erro ao deletar recebível:', error);
    }
  };

  const handleClearHistory = async () => {
    if (
      window.confirm(
        'Tem certeza de que deseja limpar todo o histórico de recebíveis?'
      )
    ) {
      try {
        await clearAllRecebiveis();
        setRecebiveis([]);
      } catch (error) {
        console.error('Erro ao limpar histórico:', error);
      }
    }
  };

  const handleFiltroChange = (key, value) => {
    setFiltro((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Layout>
      <h2 className="text-3xl font-semibold mb-6">Recebíveis</h2>
      <div className="recebiveis-page bg-gray-50 min-h-screen p-6">
        <div className="mb-8 grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1 bg-white p-6 rounded-lg shadow-md">
            <FiltroRecebiveis
              filtro={filtro}
              onFiltroChange={handleFiltroChange}
            />
          </div>

          <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                Total Recebíveis
              </h3>
              <p className="text-3xl font-bold text-gray-900">
                R$ {totalRecebiveis.toFixed(2)}
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                Pendentes
              </h3>
              <p className="text-3xl font-bold text-red-600">
                R$ {totalPendentes.toFixed(2)}
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                Recebidos
              </h3>
              <p className="text-3xl font-bold text-green-600">
                R$ {totalRecebidos.toFixed(2)}
              </p>
            </div>
          </div>
        </div>

        <div className="mb-8">
          <InserirRecebivel />
        </div>

        <div className="flex justify-end mb-8">
          <Button
            type="remover"
            label="Limpar Histórico"
            onClick={handleClearHistory}
            className="px-6 py-3 text-white font-semibold rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          />
        </div>

        <RecebiveisList
          recebiveis={recebiveis}
          onStatusChange={handleStatusChange}
          onDelete={handleDelete}
        />
      </div>
    </Layout>
  );
}

RecebiveisPage.propTypes = {
  recebiveis: PropTypes.array.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default RecebiveisPage;
